import { generateMedia } from 'styled-media-query';

export enum SCREEN_BREAKPOINTS {
  XXS = 360,
  XS = 576,
  S = 768,
  M = 992,
  L = 1200,
  XL = 1900
}

const mediaBreakpoints = generateMedia({
  XXS: `${SCREEN_BREAKPOINTS.XXS}px`,
  XS: `${SCREEN_BREAKPOINTS.XS}px`,
  S: `${SCREEN_BREAKPOINTS.S}px`,
  M: `${SCREEN_BREAKPOINTS.M}px`,
  L: `${SCREEN_BREAKPOINTS.L}px`,
  XL: `${SCREEN_BREAKPOINTS.XL}px`
});

export default mediaBreakpoints;
